module.exports = __webpack_public_path__ + "static/media/vip-entry-locked.626d4fb6.png";